import React from "react";
import { AvatarMedia } from "../common";

export type CommunityBrandHeaderProps = {
	logo?: string;
	title?: string;
};

// Compact community lockup (logo + name). Rendered centered inside each
// screen's nav row, beside the back button — the standard app-bar pattern —
// so the joined community stays visible past the first screen.
export default function CommunityBrandHeader({
	logo,
	title,
}: CommunityBrandHeaderProps) {
	if (!logo && !title) {
		return null;
	}

	return (
		<div className="flex min-w-0 items-center justify-center gap-2">
			{logo && (
				<AvatarMedia
					src={logo}
					alt=""
					className="h-8 w-8 flex-none rounded-full border border-primary-2 object-cover"
				/>
			)}
			{title && (
				<span
					className="truncate font-bold"
					style={{ fontSize: "14px", lineHeight: "17px" }}
				>
					{title}
				</span>
			)}
		</div>
	);
}
